export default __webpack_public_path__ + "static/media/one-group.e9c33d80.svg";